var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-card-toggler"},[_c('r-radio-group',{attrs:{"button-list":_vm.buttons,"active":_vm.active},on:{"change":_vm.toggleChart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }